import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfigurationService } from '../core/configuration.service';
import { MasterDataService, MasterData } from './master.data.service';


@Injectable()
export class LinkedCustomerService {
  accountHolderList: Array<any>;
  relationShipList: Array<any>;
  linkedTypeList: Array<any>;

  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient,
    private masterDataService: MasterDataService,
    private masterData: MasterData) {
    this.baseApiUrl = configurationService.BaseApiUrl;
    this.masterDataService.getAll([
      this.masterData.LinkedType,
      this.masterData.Relationship,
      this.masterData.AccountHolderType,
    ])
      .subscribe(data => {
        this.linkedTypeList = data[0];
        this.relationShipList = data[1];
        this.accountHolderList = data[2];
        console.log('Got data as ', data);
      },
        err => console.log('Get master data failed', err)
      );
  }

  getLinkTypeName(id: number): string {
    for (const linked of this.linkedTypeList) {
      if (linked.id === id) {
        return id = linked.name;
      }
    }
  }

  getRelationship(id: number): string {
    for (const relation of this.relationShipList) {
      if (relation.id === id) {
        return id = relation.name;
      }
    }
  }

  getAccountHolderType(id: number): string {
    for (const holder of this.accountHolderList) {
      if (holder.id === id) {
        return id = holder.name;
      }
    }
  }

  getByAccount(accountId: number, generalLedgerId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `linkedcustomer/account/${accountId}?generalLedgerId=${generalLedgerId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getByCustomer(customerId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `linkedcustomer/customer/${customerId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getRelatedAccountsByCustomerId(customerId: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `linkedcustomer/related/${customerId}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
}
